import React from "react";
import { TextField } from "Components/Base/Inputs/TextField";
import { Autocomplete } from "Components/Base/Inputs/Autocomplete";
import styled from "styled-components";

const StyledMUIAutocomplete = styled(Autocomplete)`
  border: 1px solid var(--colorDivider);

  legend,
  label {
    opacity: 0;
  }

  fieldset {
    border: none;
  }
`;

/**
 * En anpassad komponent för sök- och valfunktion.
 *
 * @component
 * @param {string} id - ID för komponenten.
 * @param {any} value - Värdet för komponenten.
 * @param {function} onInputChange - Funktion som anropas när input värdet ändras.
 * @param {function} onChange - Funktion som anropas när värdet ändras.
 * @param {function} onKeyPress - Funktion som anropas när en tangent ändras.
 * @param {boolean} disabled - Anger om komponenten är inaktiverad eller inte (standard: false).
 * @param {Array} options - En array med tillgängliga alternativ.
 * @param {function} groupBy - Funktion för att gruppera alternativ efter en viss egenskap.
 * @param {function} getOptionLabel - Funktion som returnerar visningslabeln för ett alternativ.
 * @param {string} className - CSS-klassnamn för att anpassa komponentens utseende.
 * @param {string} placeholder - Placeholder-text för sökfältet (standard: "Search").
 * @returns {JSX.Element} - Returnerar JSX-elementet för komponenten.
 */
const SearchSelect = ({
  id = "SearchSelectComponent",
  className,
  value,
  onInputChange,
  onChange,
  onKeyPress,
  disabled = false,
  options,
  groupBy,
  getOptionLabel,
  placeholder,
  width = "250px",
}) => (
  <StyledMUIAutocomplete
    id={id}
    className={className}
    value={value}
    onInputChange={onInputChange}
    onChange={onChange}
    onKeyPress={onKeyPress}
    disabled={disabled}
    options={options}
    groupBy={groupBy}
    {...(groupBy && groupBy)}
    getOptionLabel={getOptionLabel}
    renderInput={(params) => (
      <TextField {...params} label={placeholder} variant="outlined" />
    )}
    size="medium"
    freeSolo
    forcePopupIcon={true}
    style={{ width }}
  />
);

export default SearchSelect;
